module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "Level",
	"sourceName": "contracts/levels/base/Level-05.sol",
	"abi": [
		{
			"constant": false,
			"inputs": [],
			"name": "renounceOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "isOwner",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		}
	],
	"bytecode": "0x",
	"deployedBytecode": "0x",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/base/Level-05.sol/Level.json
// module id = 1601
// module chunks = 0